import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/brands/youlook/newsletter.png")